import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconVk$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconVk extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c08049129dcc040dac2555172948ec38c2589e40', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '05f577c18bcf739edd126c1d50fc9bd4fba57d4b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6f91df29a277667ccd9f0b86f428eff65acc5d64', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 8.7v4.6c0 4.2-1 5.2-5.2 5.2H8.7c-4.2 0-5.2-1-5.2-5.2V8.7c0-4.2 1-5.2 5.2-5.2h4.6c4.2 0 5.2 1 5.2 5.2m-2.89 5.5c.32 0 .47-.15.38-.46a4.7 4.7 0 0 0-.92-1.28c-.25-.3-.64-.63-.75-.79s-.12-.3 0-.49a14 14 0 0 0 1.47-2.51c.07-.23 0-.4-.33-.4h-1.1a.47.47 0 0 0-.47.3 9.2 9.2 0 0 1-1.35 2.24c-.25.26-.37.34-.5.34s-.18-.08-.18-.32V8.67c0-.28-.08-.4-.31-.4H9.83a.25.25 0 0 0-.27.25c0 .26.39.32.43 1.06v1.61c0 .36-.06.42-.2.42-.37 0-1.28-1.36-1.81-2.92-.11-.3-.21-.42-.49-.42H6.4c-.32 0-.38.14-.38.3a8.75 8.75 0 0 0 1.73 3.63 4.24 4.24 0 0 0 3.33 2c.7 0 .78-.15.78-.42v-1c0-.32.07-.38.29-.38s.44.08 1.09.71.86 1.07 1.28 1.07z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-vk", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-vk"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-vk":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconVk$1);
            }
            break;
    } });
}

const CosmosIconVk = CosmosIconVk$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconVk, defineCustomElement };
